import $ from "jquery";
window.jQuery = $;
window.$ = $;
import 'jquery-ui/ui/widgets/sortable'; // Import sortable widget
import 'jquery-ui/themes/base/theme.css'; // Import jQuery UI theme

import Rails from "@rails/ujs"
import * as ActiveStorage from "@rails/activestorage"
import "channels"

// Chart.js and Chartkick are loaded via CDN in application.html.erb
// Commenting out Webpack imports to avoid conflicts with CDN
// If you want to use Webpack instead, uncomment below and remove CDN scripts from layout

/*
// Chart.js must be imported and registered BEFORE Chartkick
import { Chart, registerables } from "chart.js"

// Register all Chart.js components
Chart.register(...registerables)

// Make Chart.js available globally for Chartkick (REQUIRED)
window.Chart = Chart

// Import Chartkick after Chart.js is registered and available globally
import Chartkick from "chartkick"

// Make Chartkick available globally
window.Chartkick = Chartkick
*/

// Verify CDN scripts are loaded (for debugging)
if (typeof window !== 'undefined') {
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof window.Chart === 'undefined') {
      console.error('Chart.js is not loaded! Check CDN script in layout.')
    } else {
      console.log('Chart.js loaded:', window.Chart.version || 'unknown')
    }
    
    if (typeof window.Chartkick === 'undefined') {
      console.error('Chartkick is not loaded! Check CDN script in layout.')
    } else {
      console.log('Chartkick loaded successfully')
    }
  });
}


import { initAdminDashboardDataTables } from "../admin/datatables_init";
import "datatables.net-bs5/css/dataTables.bootstrap5.css";

Rails.start()
ActiveStorage.start()
import "controllers"
// import 'stylesheets/application';

// require("turbolinks").start()

require("bootstrap/dist/js/bootstrap.bundle.min.js");

require("jquery-ui-dist/jquery-ui")

require("theme/bootstrap-datepicker.min.js")

require("theme/jquery.maskedinput.js")

// require("theme/jquery.toast.js")

//bootstrap validations
require('custom/form-validation')

//sticky header
require('custom/header-sticky')

//preloader
// require('custom/preloader')

//back to top
require('custom/topTop')


//Header sticky on reverse scroll
require('custom/header-sticky-reverse')

//On scroll animations
// require('custom/aos')
require("custom/jquery.maskedinput.js")

//Lightbox for image/video popups
require('custom/glightbox')

//Portfolio filter / masonry layouts
require('custom/isotope-layout')

//background image/video parallax
require('custom/jarallax')

//Smooth scroll
require('custom/smooth-scroll')

//Inject image[svg] to svg
require('custom/svgInjector')

//Typed Text
require('custom/typed')

//Element parallax
require('custom/rellax')
require('masterslider/jquery.easing.min.js')
require('masterslider/masterslider.min.js')
// require('custom/swiper-bundle.min.js')

$(document).ready(function () {
  //attach csrf token with every ajax
  $.ajaxSetup({
    'global': true,
    headers: {
      'X-CSRF-Token': $('meta[name="csrf-token"]').attr('content')
    }
  });
});

$(function() {
  window.jQuery(".datepicker_tday").datepicker({
    format: "mm/dd/yyyy"
  })
  // window.jQuery(".datetimepicker1").datetimepicker()
  // window.jQuery("#sortable").sortable()

})

$(document).ready(function () {
  confirm_rails();
  $(".phone_no_masked").mask("(999) 999-9999");
});

function confirm_rails() {
  $(document).on('mousedown', 'a[data-confirm]', function (e) {
    let $ = window.$b;
    e.preventDefault();
    let link = window.jQuery(this)
    let message = link.data('confirm');
    let modal = window.jQuery("#modal_confirm");
    modal.find('.modal-body').text(message)
    let approve = modal.find('.approve')
    let approve_txt = link.attr('data-approve-text');
    approve.attr('data-method', link.data('method'));
    approve.attr('href', link.attr('href'));
    approve_txt == '' ? 'OK' : approve.text(approve_txt)
    modal.modal('show')
  });
}

document.addEventListener('DOMContentLoaded', function() {
  const adminDropdownToggle = document.querySelector('.admin_menu_dropdown .nav-link');
  const adminDropdown = document.querySelector('.admin_menu_dropdown .dropdown-menu');
  const adminDropdownParent = document.querySelector('.admin_menu_dropdown');
  
  if (adminDropdown && adminDropdownToggle) {
    
    // Prevent dropdown from closing when hovering or clicking on collapsible sections
    adminDropdown.addEventListener('click', function(e) {
      // Don't close dropdown when clicking on collapsible headers or nested items
      if (e.target.closest('.admin-section-header') || e.target.closest('.admin-nested-items')) {
        e.stopPropagation();
      }
    });
    
    // Prevent dropdown from closing on hover events
    adminDropdown.addEventListener('mouseenter', function(e) {
      e.stopPropagation();
    });
    
    adminDropdown.addEventListener('mouseleave', function(e) {
      e.stopPropagation();
    });
    
    // Keep dropdown open when mouse moves between toggle and dropdown
    let hoverTimer = null;
    
    function clearHoverTimer() {
      if (hoverTimer) {
        clearTimeout(hoverTimer);
        hoverTimer = null;
      }
    }
    
    function startHoverTimer() {
      clearHoverTimer();
      hoverTimer = setTimeout(() => {
        if (adminDropdownParent.querySelector('.dropdown-menu.show')) {
          bootstrap.Dropdown.getInstance(adminDropdownToggle)?.hide();
        }
      }, 300); // 300ms delay before closing
    }
    
    // Handle mouse events on the entire dropdown parent
    adminDropdownParent.addEventListener('mouseenter', function(e) {
      clearHoverTimer();
    });
    
    adminDropdownParent.addEventListener('mouseleave', function(e) {
      // Only start timer if we're really leaving the dropdown area
      const rect = adminDropdownParent.getBoundingClientRect();
      const mouseX = e.clientX;
      const mouseY = e.clientY;
      
      // Check if mouse is still within dropdown bounds (with small buffer)
      if (mouseX < rect.left - 10 || mouseX > rect.right + 10 || 
          mouseY < rect.top - 10 || mouseY > rect.bottom + 10) {
        startHoverTimer();
      }
    });
    
    // Handle collapsible section animations
    const collapsibleSections = adminDropdown.querySelectorAll('.collapse');
    
    collapsibleSections.forEach(section => {
      section.addEventListener('show.bs.collapse', function() {
        const header = document.querySelector(`[data-bs-target="#${this.id}"]`);
        if (header) {
          header.classList.remove('collapsed');
        }
      });
      
      section.addEventListener('hide.bs.collapse', function() {
        const header = document.querySelector(`[data-bs-target="#${this.id}"]`);
        if (header) {
          header.classList.add('collapsed');
        }
      });
    });
    
    // Prevent Bootstrap's auto-close behavior on hover
    adminDropdownToggle.addEventListener('shown.bs.dropdown', function() {
      // Override Bootstrap's default hover behavior
      adminDropdown.addEventListener('mouseover', function(e) {
        e.stopPropagation();
      });
    });
  }
  
  // Close other sections when one is opened (accordion-like behavior)
  const adminSectionHeaders = document.querySelectorAll('.admin-section-header');
  
  adminSectionHeaders.forEach(header => {
    header.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      
      const targetId = this.getAttribute('data-bs-target');
      const targetElement = document.querySelector(targetId);
      
      if (targetElement) {
        const bsCollapse = new bootstrap.Collapse(targetElement, {
          toggle: true
        });
      }
      
      // Optional: Uncomment below to make it accordion-style (only one section open at a time)
      /*
      const allSections = document.querySelectorAll('.admin-collapsible-section .collapse');
      allSections.forEach(section => {
        if (section.id !== targetId.substring(1)) {
          const bootstrap_collapse = bootstrap.Collapse.getInstance(section);
          if (bootstrap_collapse) {
            bootstrap_collapse.hide();
          }
        }
      });
      */
    });
  });
});

function initAdminDashboard() {
  initAdminDashboardDataTables();
  
  // Ensure Chart.js and Chartkick are ready
  if (typeof window.Chart === 'undefined') {
    console.error('Chart.js is not available. Charts will not render.');
    return;
  }
  
  if (typeof window.Chartkick === 'undefined') {
    console.error('Chartkick is not available. Charts will not render.');
    return;
  }
  
  // Redraw Chartkick charts on Turbolinks navigation
  if (window.Chartkick && typeof window.Chartkick.eachChart === 'function') {
    try {
      window.Chartkick.eachChart(function(chart) {
        if (chart && typeof chart.redraw === 'function') {
          chart.redraw();
        }
      });
    } catch (e) {
      console.warn('Error redrawing charts:', e);
    }
  }
}

// Initialize on page load
document.addEventListener('DOMContentLoaded', function() {
  // Small delay to ensure Chart.js and Chartkick are fully loaded
  setTimeout(initAdminDashboard, 100);
});

// Initialize on Turbolinks navigation
document.addEventListener('turbolinks:load', function() {
  setTimeout(initAdminDashboard, 100);
});